import { useHookstate } from "@hookstate/core";
import { rootComponentsStore } from "../hookstate/rootComponentsStore";
import { useIsSmallBreakpoint } from "../utils/useBreakpoints";

// Hybrid-sticky hide is mobile/small-screen only — at desktop sizes the
// navbar stays anchored. The hide is also suppressed whenever a menu or the
// mobile sidebar is open, so the navbar and sub-headers stay anchored while
// scroll is locked.
export function useIsTopBarHidden() {
  const hidden = useHookstate(rootComponentsStore.isTopBarHidden).get() ?? false;
  const openMenu = useHookstate(rootComponentsStore.openSlideInMenu).get();
  const isSidebarOpen = useHookstate(rootComponentsStore.isSidebarOpen).get();
  const isSmall = useIsSmallBreakpoint();
  const isMenuOpen = !!openMenu || (isSmall && isSidebarOpen);
  return hidden && isSmall && !isMenuOpen;
}
